module.exports = __webpack_public_path__ + "static/media/error.8f4f07ec.png";